var map = {
	"./de.js": 524,
	"./en-gb.js": 913,
	"./et.js": 523,
	"./fi.js": 525,
	"./lt.js": 526,
	"./lv.js": 527,
	"./ru.js": 528,
	"./tet.js": 914
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 912;